/* eslint-disable global-require,import/no-unresolved, react/forbid-prop-types, react/no-array-index-key */
import React from 'react'
import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import styles from '../../../styles'
import textStyles from '../../../styles/text'

function RemoteScheduledFollowUp() {
  const { t } = useTranslation('faq')
  return (
    <View>
      <View style={textStyles.faqH1Container}>
        <Text style={[textStyles.h1, styles.shark_grey]} testID="what-remote-sched-followup-header">{t('whatIsRemoteSchedFollowup')}</Text>
      </View>
      <View>
        <Text style={textStyles.bodyContentText}>{t('remoteFollowUpParagraph1')}</Text>
      </View>
    </View>
  )
}
export default RemoteScheduledFollowUp
